/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { PieChartProps } from '../../PieChart.props';

export const getPieChartData = (options: PieChartProps): Highcharts.Options => {
  const { chartData, seriesName } = options;
  return {
    series: [
      {
        allowPointSelect: true,
        data: chartData,
        name: seriesName,
        showInLegend: true,
        type: 'pie',
      },
    ],
  };
};
